import AssetTypeForm from './AssetTypeForm';

export default AssetTypeForm;
export * from './AssetTypeForm';
